import * as React from 'react';

// utils
import { getTrackingFlowSubType } from 'utils/analytics';

// constants
import { WIDGET_NAME } from '@sitegen/common/constants';

// components
import Login, { Types as LoginTypes } from 'modules/login';
import BaseScreen from '../../modules/base-screen';

interface ILoginScreenProps {
    widgetName: WIDGET_NAME;
}

const LoginScreen: React.FC<ILoginScreenProps> = ({ widgetName }) => {
    const loginProps = {
        additionalAnalyticsInfo: {
            flowSubType: getTrackingFlowSubType(widgetName)
        }
    } as LoginTypes.ILoginProps;

    return <BaseScreen>
        <Login {...loginProps}/>
    </BaseScreen>;
};

export default LoginScreen;
